import useSWR from 'swr';
import { useCallback } from 'react';
import type { UseFetchProps } from './useFetch.types';
import { fetcher } from '@/shared/utils/api/fetcher';

export const useFetch = <T>(props: UseFetchProps) => {
  const { url, options, swrConfig, requiresAuth = false } = props;

  // Stable fetcher that receives the key from SWR
  const swrFetcher = useCallback(
    (key: string) => fetcher<T>({ url: key, options, requiresAuth }),
    [options, requiresAuth]
  );

  const { data, error, isLoading, mutate } = useSWR<T>(url, swrFetcher, {
    revalidateOnFocus: false,
    revalidateIfStale: false,
    shouldRetryOnError: false,
    dedupingInterval: 0,
    ...swrConfig,
  });

  return { data, error, isLoading, mutate };
};
